/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { FormEditableInput } from '../elements/EditableInput';
import * as Actions from '../../actions/actions';
import { featureToggle } from '../../services/FeatureToggle';

/* eslint max-len: 0 */
export class SendMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.person.get('message'),
        };
    }

    componentWillMount() {
        this.props.actions.createMessage();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ message: nextProps.person.get('message') });
    }

    onChange(event) {
        this.setState({ message: event.target.value });
    }

    handleChange(event) {
        this.props.actions.updatePersonAttribute(event.target.name, event.target.value);
        this.forceUpdate();
    }

    onBlur(event) {
        this.props.actions.updatePersonAttribute('message', event.target.value);
    }

    render() {
        const maxWidthInputs = this.props.person.get('adviceArea') === 392 ? '280px' : 'auto';
        return (
            <div className="app__message-page__container">
                <div className="app__editable-input">
                    <textarea className="app__text-area" rows="5"
                              onChange={ this.onChange.bind(this) }
                              onBlur={ this.onBlur.bind(this) }
                              value={ this.state.message }/>
                </div>
                <FormEditableInput name="phone"
                                   ref="phone"
                                   label="The best number to contact me on is:"
                                   placeholder="01234 567 890"
                                   value={ this.props.person.get('phone') }
                                   maxLength={ 11 }
                                   invalidSubmit={ this.props.invalidSubmit }
                                   widthProportion="fixed"
                                   fixedWidth={ maxWidthInputs }
                                   handleChange={ this.handleChange.bind(this) }
                                   hintText="Most advisers will call you to discuss your request"
                                   required/>

            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),
        invalidSubmit: state.navigation.get('invalidSubmit'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SendMessage);



// WEBPACK FOOTER //
// ./src/components/steps/SendMessage.jsx